import { Controller } from "@hotwired/stimulus"

/**
 * Weld Results Controller
 * Handles Area % vs From/To range toggle for weld inspection results
 * Manages enable/disable state of input fields based on checkbox
 */
export default class extends Controller {
  static targets = ["areaInput", "fromInput", "toInput"]

  connect() {
    console.log('[weld-results] Controller connected')
  }

  /**
   * Toggle between Area % mode and From/To range mode
   * When checkbox is checked: Area % is disabled, From/To are enabled
   * When checkbox is unchecked: Area % is enabled, From/To are disabled
   */
  toggleAreaMode(event) {
    const checkbox = event.currentTarget
    const weldId = checkbox.dataset.weldId
    const isRangeMode = checkbox.checked

    console.log('[weld-results] Toggle area mode:', {
      weldId,
      isRangeMode,
      checked: checkbox.checked
    })

    // Find the specific inputs for this weld
    const areaInput = this.element.querySelector(`input[data-weld-results-target="areaInput"][data-weld-id="${weldId}"]`)
    const fromInput = this.element.querySelector(`input[data-weld-results-target="fromInput"][data-weld-id="${weldId}"]`)
    const toInput = this.element.querySelector(`input[data-weld-results-target="toInput"][data-weld-id="${weldId}"]`)

    if (!areaInput || !fromInput || !toInput) {
      console.error('[weld-results] Could not find input fields for weld:', weldId)
      return
    }

    if (isRangeMode) {
      // Range mode: disable area, enable from/to
      areaInput.disabled = true
      areaInput.value = '' // Clear area value when switching to range mode
      fromInput.disabled = false
      toInput.disabled = false

      console.log('[weld-results] Switched to Range mode (From/To enabled)')
    } else {
      // Area mode: enable area, disable from/to
      areaInput.disabled = false
      fromInput.disabled = true
      toInput.disabled = true
      fromInput.value = '' // Clear range values when switching to area mode
      toInput.value = ''

      // Set default area value if empty
      if (!areaInput.value) {
        areaInput.value = '100%'
      }

      console.log('[weld-results] Switched to Area % mode (Area enabled)')
    }

    // Dispatch event for potential autosave integration
    this.dispatch('mode-changed', {
      detail: {
        weldId,
        mode: isRangeMode ? 'range' : 'area'
      }
    })
  }
}
